/*
 * The reply box's signature contract (docs/2026-11-03-reply-box-mailbox-signature.md): what the
 * reply-sender and Mailboxes signature routes answer and accept, shared by the server and the
 * browser. Zod only: nothing here may import server code.
 */
import { z } from "zod";

/** The ending a reply from one mailbox carries, and where it came from. */
const ReplySignatureSchema = z.strictObject({
  html: z.string(),
  plainText: z.string(),
  source: z.enum(["leadcue", "bison"]),
});
export type ReplySignature = z.infer<typeof ReplySignatureSchema>;

/** The sender a reply goes out as; `signature` is null when the mailbox has none. */
export const ReplySenderSchema = z.strictObject({
  address: z.string(),
  name: z.string().nullable(),
  signature: ReplySignatureSchema.nullable(),
});
export type ReplySender = z.infer<typeof ReplySenderSchema>;

/** One reply-only override typed in LeadCue. */
export const ReplySignatureOverrideSchema = z.strictObject({
  address: z.string(),
  plainText: z.string(),
  revision: z.number().int().positive(),
  updatedAt: z.string(),
});
export type ReplySignatureOverride = z.infer<typeof ReplySignatureOverrideSchema>;

/** The workspace's overrides; a mailbox not listed uses its Bison signature. */
export const MailboxReplySignaturesSchema = z.strictObject({
  signatures: z.array(ReplySignatureOverrideSchema),
});
export type MailboxReplySignatures = z.infer<typeof MailboxReplySignaturesSchema>;

/** `expectedRevision` 0 means "no override yet". */
export const SaveReplySignatureSchema = z.strictObject({
  plainText: z.string().trim().min(1).max(2000),
  expectedRevision: z.number().int().nonnegative(),
});
